export const wallet = {
    id: "inApp",
    name: "Social Login",
    homepage: "https://thirdweb.com",
    app: {
        browser: null,
        ios: null,
        android: null,
        mac: null,
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: null,
        universal: null,
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map